import { TableItemActionsNew } from '../../../../components';
const columns = (actionsList, setSelectedRow, setRemoveDialog) => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '10%',
    },
  },
  {
    title: 'نوع کاربر',
    field: 'type',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '5%',
    },
    headerStyle: {
      width: '5%',
    },
    render: (rd) => rd?.isBranch ? 'حقوقی(شعب)' : 'حقیقی(پادی)'
  },


  {
    title: 'نام',
    field: 'given_name',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '5%',
    },
    headerStyle: {
      width: '5%',
    },
    render: (rd) =>
      rd?.businessName
        ? rd?.businessName
        : rd?.given_name
          ? `${rd?.given_name || ''} ${rd?.family_name || ''}`
          : '-',
  },

  ...((actionsList['deleteACLBtn']) ? [{
    title: 'عملیات',
    field: '',
    filtering: false,
    sorting: false,
    align: 'right',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
    render: (rowData) => (
      <TableItemActionsNew
        iconButton
        title=""
        otherMenus={[
          {
            title: 'حذف ',
            isShow: true,
            onClick: () => {
              setSelectedRow(rowData);
              setRemoveDialog({
                title: 'حذف دسترسی کاربر',
                content: 'آیا از حذف این کاربر اطمینان دارید؟',
                open: true,
              });
            },
          },
        ]}
      />
    ),

  }] : []),
];

const generateData = (rows, query) => {
  return rows?.map?.((row, key) => ({
    num: query?.page * query?.pageSize + key + 1,
    ...row,
  }));
};

export { columns, generateData };
